export interface AddressFormData {
    street?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: string;
}
